





import Vue from 'vue';
import store from '../store';
import Tooltip from 'tooltip.js';

export default Vue.component('bacon-tooltip', {
    data() {
        return {
            tooltip: null as null |Tooltip,
        };
    },
    props: ['content'],
    mounted() {
        this.tooltip = new Tooltip(this.$el, {
            title: this.content,
            placement: 'right-start',
            html: true,
            trigger: 'click',
            template: '<div class="bacon-tooltip popper" role="tooltip"><div class="bacon-tooltip-arrow"></div>' +
                '<div class="bacon-tooltip-inner"></div></div>',
            arrowSelector: '.bacon-tooltip-arrow',
            innerSelector: '.bacon-tooltip-inner',
            offset: '0, 15',
        } as any);
    },
    destroyed() {
        if (this.tooltip) {
            this.tooltip.dispose();
        }
    },
});
